import { Component } from 'react';
import NesGraphics from "../services/NesGraphics";

import "./ChrFile.scss";

export class ChrFile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            img: null,
            isMeta: !!props.isMeta 
        }
    }

    componentDidMount() {
        this.fetchImage();
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        this.fetchImage();
    }

    async fetchImage() {
        if (!this.props.data || !this.props.palette) { 
            return;
        }
        // Make big editable image/editor, allow patching on typing/clicking.
        // on mount, load all in sequence, keep a copy, compare old/new, update image only where required.
        this.setState({
            img: this.state.isMeta ? 
                await NesGraphics.convertMetaToBase64Image(this.props.data, this.props.palette, this.props.tileId ?? null)
                : await NesGraphics.convertToBase64Image(this.props.data, this.props.palette, this.props.tileId ?? null)
        });
    }

    render() {
        return (
            <div className="chr-file">
                <img alt="Chr Tile" src={this.state.img} draggable={false} />
            </div>
        );
    }
}